import { Component, OnInit, OnDestroy } from '@angular/core';
import { ModalService } from '@services/modal.service';
import { HelperService } from '@services/helper.service';
import { AuthService } from '@services/auth.service';
import { CashNowService } from '@app/services/cash-now.service';

@Component({
  selector: 'app-modal-logout',
  templateUrl: './modal-logout.component.html',
  styleUrls: ['./modal-logout.component.scss'],
})
export class ModalLogoutComponent implements OnInit, OnDestroy {
  constructor(
    private auth: AuthService,
    private cashNow: CashNowService,
    public modal: ModalService,
    public helper: HelperService,
  ) {}

  ngOnInit() {}

  ngOnDestroy() {
    this.modal.close();
  }

  logOut() {
    if (sessionStorage.getItem('cajaYa')) {
      this.cashNow.deleteCheckedBills().subscribe(
        (res) => {
          console.log(res.message);
          this.helper.logOut();
        },
        (error) => {
          console.log(error);
          this.helper.logOut();
        }
      );
    } else {
      this.helper.logOut();
    }
    
    (window as any).gtag('event', 'cerrar-sesion-conrmada', {
      event_category: 'cerrar-sesión',
      event_label: `${this.auth.identity.userInfo.documentType}:${this.auth.identity.userInfo.document}:1;${this.auth.identity.username}`,
    });
  }
}
